import { useAuthSelector, useIsLoggedIn } from "@nf/common";

export const useIsAuthenticated = () => {
  const { user, isChild, isProcessing } = useAuthSelector();
  const isLoggedIn = useIsLoggedIn();
  const isRegisteredViaCampaign = user?.UtmCampaign === "aeldresagen";

  return {
    isLoggedIn,
    isChild,
    isProcessing,
    isRegisteredViaCampaign,
  };
};
